export default __webpack_public_path__ + "static/media/Analyze.87b08f72.png";